import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { ContentCampaignStepOneGetResourceModel } from '@/modules/content-campaign/models/content-campaign-resource.model'
import { ContentCampaignSaveRequestModel } from '@/modules/content-campaign/models/content-campaign-request.model'
import { ContentItemStepOneSaveDraftCollection } from '@/modules/content-item/models/content-item-collection.model'
import { PanelContentCampaignService } from '@/modules/content-campaign/services/panel-content-campaign.service'
import { removeUndefinedValues } from '@/modules/shared/helpers/utils/utils'

@vservice()
export class PanelContentCampaignSaveCampaignUseCase implements BaseRequestLoadingHandler {
  constructor(private readonly service: PanelContentCampaignService) {}

  isLoading = false
  isSuccess = false

  execute(data: ContentCampaignStepOneGetResourceModel) {
    return this.service
      .saveCampaign(removeUndefinedValues(this.requestData(data), 'attachments'))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  saveDraft(data: ContentCampaignStepOneGetResourceModel) {
    return this.service
      .saveDraft(removeUndefinedValues(this.requestData(data), 'attachments'))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  async destroyItem(campaignId, itemId): Promise<any> {
    return this.service.destroyItem(campaignId, itemId)
  }

  requestData(data: ContentCampaignStepOneGetResourceModel): ContentCampaignSaveRequestModel {
    let items: ContentItemStepOneSaveDraftCollection[] = []
    data.items.forEach(item => {
      items.push({
        id: item?.id,
        content_type: item.content_type,
        description: item.description,
        keywords: item.keywords,
        main_keyword: item.main_keyword,
        title: item.title,
        tone: item.tone,
        word_count: item.word_count,
        ai_type: item.ai_type,
      })
    })
    return {
      attachments: data.attachments.filter(item => item instanceof File),
      description: data.description,
      items: items,
      references_url: data.references_url,
      title: data.title,
      campaign_id: data?.id
    }
  }
}
